import { useEffect, useState, createContext, useContext } from "react";
import axios from "axios";
import { apiEndPoint } from '../../environment'
import { useNavigate } from "react-router-dom";
import { LoginContext } from "./LoginContext";
import { SelectSiteContext } from "./SelectSite";

const siteDetailsContext = createContext()

export { siteDetailsContext }

const SiteDetailsProvider = ({ children }) => {

    const [response, setResponse] = useState([])
    const [error, setErrors] = useState("");
    const [loadingLogin, setLoadingLogin] = useState(false);
    const { user, addSite } = useContext(LoginContext)
    const navigate = useNavigate()

    let cancleToken = axios.CancelToken.source();
    const urlEndPoint = 'sitedetails/userId'

    const siteDetails = () => {
        setLoadingLogin(true)
        let data = JSON.stringify({
            "userId": user?.id
        });
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${apiEndPoint}${urlEndPoint}`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data,
            cancleToken: cancleToken.token,
        };
        axios(config).then((response) => {
            setResponse(response.data.data)
            if (response.data.data <= 0) {
                navigate("/account/add-site");
            } else if(!localStorage.getItem('currentSideId')) {
                navigate("/account/select-site");
            }
            setLoadingLogin(false)
        }).catch((error) => {
            setErrors(error.response.data.message)
            setLoadingLogin(false)
        })
    }

    const contextData = {
        siteDetails: response,
        loading: loadingLogin
    }

    useEffect(() => {
        if (addSite) {
            siteDetails()
        }
    }, [addSite])

    return (
        <siteDetailsContext.Provider value={contextData}>
            {loadingLogin ? null : children}
        </siteDetailsContext.Provider>
    )
}

export default SiteDetailsProvider;
